import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { State } from 'app/e-form/model/eform-type';
import { EFormHelper } from 'app/e-form/helper/script/helper';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-email-properties',
  templateUrl: './email-properties.component.html',
  styleUrls: ['./email-properties.component.scss']
})
export class EmailPropertiesComponent implements OnInit {
   @Input() eForm: FormGroup;
   @Input() state: State;
   @Input() table: State;
   @Output() sendFocus = new EventEmitter<boolean>();
   helper = new EFormHelper();
   displayDisabled: boolean;
   @Input() eventsStateChild: Observable<void>;

   constructor() { }

   ngOnInit(): void {
      this.helper.checkDisplayDisabled(this.eForm, this.state, this.table);
      this.helper.displayDisabledChanges.subscribe((value) => {
         this.displayDisabled = value;
      });
      this.eventsStateChild.subscribe(() => {
         this.helper.checkDisplayDisabled(this.eForm, this.state, this.table);
      });
   }

   sendFocusToCreate(focus: boolean) {
      this.sendFocus.emit(focus);
   }


}
